import { useParams } from 'react-router-dom'
import GokuDataGrid from '@/components/GokuDataGrid'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getItems } from '../../services'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Item } from '../../types/response'
import { Chip, Typogaphy } from 'vnetwork-ui'
import CellLink from '@/components/GokuDataGrid/CellLink'
import { paths } from '@/utils/path'
import { getEquipmentStatusColor } from '../../utils'

// Columns for equipment in this rack (only equipment, not components)
const equipmentColumns: GridColDefVNW<Item>[] = [
    {
        field: 'name',
        headerName: 'Equipment Name',
        width: 280,
        renderCell: ({ row }) => (
            <CellLink to={`${paths.warehouseEquipment}/${row?.id}`}>
                {row?.name}
            </CellLink>
        ),
    },
    {
        field: 'service_tag',
        headerName: 'Service Tag / Ref',
        width: 180,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row?.service_tag || row?.ref || '-'}
            </Typogaphy>
        ),
    },
    {
        field: 'rack_position_u',
        headerName: 'Rack Position',
        width: 130,
        headerClassName: 'text-center',
        renderCell: ({ row }) => (
            <Typogaphy
                size="small"
                className="text-center w-full font-semibold"
            >
                {row?.rack_position_u ? `U${row.rack_position_u}` : '-'}
            </Typogaphy>
        ),
    },
    {
        field: 'rack',
        headerName: 'Rack',
        width: 180,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row?.rack?.name || row?.rack?.code || '-'}
            </Typogaphy>
        ),
    },
    {
        field: 'category',
        headerName: 'Category',
        width: 150,
        renderCell: ({ row }) => (
            <Typogaphy size="small" className="capitalize">
                {row?.category}
            </Typogaphy>
        ),
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 140,
        headerClassName: 'text-center',
        renderCell: ({ row }) => (
            <Chip
                label={row?.status}
                size="small"
                className="min-w-[100px] flex justify-center capitalize"
                variant="contained"
                color={getEquipmentStatusColor(row?.status)}
            />
        ),
    },
    {
        field: 'model',
        headerName: 'Model',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.model?.name || '-'}</Typogaphy>
        ),
    },
    {
        field: 'serial_number',
        headerName: 'Serial Number',
        width: 180,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.serial_number || '-'}</Typogaphy>
        ),
    },
]

const RackEquipment = () => {
    const { id } = useParams<{ id: string }>()

    // Filter equipment items by rack_id
    // Only show equipment items (not components) as components are installed in equipment
    return (
        <div className="mt-2">
            <GokuDataGrid
                apiCall={(params) =>
                    getItems({ ...params, rack_id: id, item_type: 'equipment' })
                }
                reactQueryKey={`${QUERY_KEYS.WAREHOUSE_ITEMS}-rack-${id}`}
                columns={equipmentColumns}
                dataGridProps={{
                    getRowId: (row) => row?.id,
                    initialState: {
                        sorting: {
                            sortModel: [
                                { field: 'rack_position_u', sort: 'desc' },
                            ],
                        },
                    },
                }}
                actions={[]}
                filterDefaultValues={{
                    category: '',
                    status: '',
                }}
            />
        </div>
    )
}

export default RackEquipment
